import {LitElement} from 'lit';
import AbstractUserUtils from '@mta/common-js/src/user/abstract-user-utils';
import FileSecuredServiceClientProxy from '@mta/file-js/gen/com/alstom/file/service/FileSecuredServiceClientProxy.js';
import MsgpackJsonAuthClient from '@mta/msgpack-js-lib/src/MsgpackJsonAuthClient.js';

export default class B2bElement extends LitElement {
  /**
   * @return {MsgpackJsonFetchClient}
   */
  msgpackClientPublic() {
    return MsgpackJsonAuthClient.build(window.conf.serverPublicAddress + '/public');
  }

  /**
   * @return {MsgpackJsonFetchClient}
   */
  msgpackClientAdmin() {
    return MsgpackJsonAuthClient.build(window.conf.serverPublicAddress + '/admin');
  }

  redirect(path) {
    window.history.pushState({}, null, path);
    window.dispatchEvent(new CustomEvent('location-changed'));
  }

  formatUser(user) {
    return user === null ? '' : AbstractUserUtils.formatUser(user);
  }
}
